<template>
  <div class="box">

    <div class="handle-box-search">

      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 80px;">数据表名称:</span>
        <el-input v-model="submit_data.table_name" style="width: 100px;"></el-input>


      </el-row>
      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 80px;">S-KEY密码:</span>
        <el-input v-model="submit_data.s_key" style="width: 100px;"></el-input>


      </el-row>

      <el-row type="flex" justify="center">

        <el-button type="primary" @click="upTableSubmit">缓存更新</el-button>


      </el-row>



    </div>




  </div>

</template>

<script>
  var _this;
  export default {

    data() {
      return {
        submit_data: {
          table_name: '',
          s_key: ''
        },

      };
    },
    created() {
      _this = this;
    },

    methods: {
      upTableSubmit() {

        _this.$post(
          "/system/upTableSubmit",
          _this.submit_data
        ).then(res => {

          _this.$message.success(res.msg);


        }).catch((err) => {

        })
      },
    }
  };
</script>

<style scoped>

</style>